import React from "react";
import { Box } from "@mui/material";

const DialogLayout = ({ children, height = { xs: '50vh', md: '51vh', lg: '60vh' } }) => {
  return (
    <Box sx={{ height: height, overflowX: 'auto', paddingRight: 1 }}>
      {children}
    </Box>
  )
};

export default DialogLayout;